<template>
  <div v-for="folder in folders" :key="folder.name">
    <div class="row" v-if="!((folder.name == 'internal') && behavior != 'admin')">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title inline">{{ folder.name }}</h5><span v-if="folder.name == 'uploads'">&nbsp;<i
                class="bi bi-info-circle" @click="info"></i></span>
            <div class="row" v-if="!((folder.name == 'reports') && behavior != 'admin')">
              <div class="col-sm-8">
                <input type="file" class="form-control" @change="handleFileUpload($event)" />
              </div>
              <div class="col-sm-4 text-center">
                <button @click="UploadFile(folder.name)" class="btn btn-primary">
                  Upload
                </button>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-sm-12">
                <ul class="no-bullets">
                  <li class="" v-for="file in folder.files" :key="file.Name">
                    <div class="row">
                      <div class="col-sm-6">
                        <i class="bi bi-collection me-1 text-primary"></i>
                        <a href="#" @click="downloadFile(folder.name, file.name)">
                          {{ file.name }}
                        </a>
                      </div>
                      <div class="col-sm-6">
                        <a v-if="!isConsultant" href="#" @click="deleteFile(folder.name, file.name, $event)"><i
                            class="bi bi-trash me-1 text-primary"></i></a>
                      </div>
                    </div>


                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>



  <button style="display:none;" type="button" class="btn btn-primary" data-bs-toggle="modal"
    data-bs-target="#mdlInfoUploads" id="btnOpenInfoUploads">Open</button>
  <div class="modal fade" id="mdlInfoUploads" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Information Required</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              <p>For each project we require the following information:</p>
              <ul>
                <li>Proposed construction details for roof, ceilings, walls & floors.</li>
                <li>Structural framing details including; spacing (ctr distances), framing material & dimensions (i.e
                  C15019 steel joists @ 400ctrs).</li>
                <li>Details of sarking, insulated foil or bulk insulation for all envelope fabrics.</li>
                <li>Detail of any thermal breaks and application.</li>
                <li>Window schedule, including proposed glazing U-value & SHGC.</li>
                <li>Reflected Ceiling plan to show eave and shading projections.</li>
              </ul>
              <p>Note, most information is gathered from the drawings you provide. Please ensure the drawings uploaded
                include the information as itemised above.</p>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "project-cmp",
  components: {},
  props: ["idProject", "behavior"],
  data: function () {
    return {
      folders: [],
      loaded: false,
    };
  },
  mounted() {
    let self = this;

    this.$vtc
      .vtcFetch("/Project/GetProject/?id=" + this.idProject, null,'API2')
      .then(function (data) {
        self.project = data;

        self.loaded = true;
      });

    this.$vtc
      .vtcFetch("/Project/GetProjectFiles/?id=" + this.idProject, null,'API2')
      .then(function (data) {
        self.folders = data;

        self.loaded = true;
      });
  },
  computed: {
    isConsultant() {
      return this.$vtc.isConsultant();
    },
  },
  methods: {
    async downloadFile(folder, file) {
      let options = {
        folder,
        file,
        projectId: this.idProject,
      };
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      console.log(options);
      let dir = process.env.VUE_APP_API_URL

      let response = await fetch(dir + "/Project/downloadFile", {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(options),
      });

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Create a hidden anchor element to trigger the download.
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = file;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    },

    handleFileUpload(event) {
      this.file = event.target.files[0];
      console.log("archivo", this.file);
    },

    UploadFile(folder) {
      let formData = new FormData();

      formData.append("file", this.file);

      formData.append("projectId", this.idProject);
      formData.append("folder", folder);

      let self = this;
      this.$vtc.vtcFetch("/Project/UploadFile", formData,'API2').then(function (data) {
        console.log(data);
        alert("uploaded");
        let localFolder = self.folders.find((x) => x.name == folder);
        console.log(self.file);
        localFolder.files.push({ name: self.file.name });
      });

      return formData;
    },
    info() {
      document.getElementById('btnOpenInfoUploads').click();
    },
    deleteFile(folder, file, e) {
      e.preventDefault();
      if (this.isConsultant) return;

      let self = this;
      if (confirm("Are you sure to delete?")) {
        this.$vtc.vtcFetch("/Project/DeleteFile?id=" + this.idProject + "&folder=" + folder + "&fileName=" + file, null,'API2')
          .then(function () {
            let folderS = self.folders.find(function (fl) { return fl.name == folder; });
            folderS.files = folderS.files.filter(function (x) { return x.name != file; });
          });
      }
    }
  },
};
</script>
<style scoped>
.inline {
  display: inline-block !important;
}

ul.no-bullets {
  list-style-type: none;
  /* Remove bullets */
  padding: 0;
  /* Remove padding */
  margin: 0;
  /* Remove margins */
}
</style>
